<template>
  <div class="newsletter-type-subscriber-items">
    <div v-for="subscription in subscriptions" class="subscribers">
      <router-link :to="{
        name: 'newsletter_type_subscriber',
        params: { newsletterTypeSubscriberId: subscription.id }
      }"
        :class="subscription.status"
      >
        {{ subscription.subscriber_email }}
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    subscriptions: {
      type: Array
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeSubscriberItems.vue